import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = ["src"]

import { computed } from "vue";
import { parseVideoData } from "./video-data";


export default /*@__PURE__*/_defineComponent({
  __name: 'video-viewer',
  props: {
    videoLink: String,
},
  setup(__props) {

const props = __props;

const videoData = computed(() => {
    return parseVideoData(props.videoLink);
});

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("div", null, [
    (videoData.value?.type === 'youtube')
      ? (_openBlock(), _createElementBlock("iframe", {
          key: 0,
          class: "youtube-iframe",
          src: `https://www.youtube-nocookie.com/embed/${videoData.value.id}?fs=0&iv_load_policy=3&rel=0`,
          title: "YouTube video player",
          frameborder: "0",
          allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
          allowfullscreen: ""
        }, null, 8 /* PROPS */, _hoisted_1))
      : _createCommentVNode("v-if", true)
  ], 512 /* NEED_PATCH */)), [
    [_vShow, videoData.value != null]
  ])
}
}

})